<template>
  <section class="patient-header">
    <div class="patient-header__main">
      <div class="patient-header__identity">
        <div class="patient-header__avatar" aria-hidden="true">
          <i class="far fa-user"></i>
        </div>
        <div class="patient-header__info">
          <h1 class="patient-header__name">{{ patient.name }}</h1>
          <div class="patient-header__meta-row">
            <span class="patient-header__meta">
              <i class="fas fa-phone-alt"></i>
              <span>{{ patient.phone }}</span>
            </span>
            <span class="patient-header__meta">Năm sinh: {{ patient.birthYear }}</span>
          </div>
          <div class="patient-header__meta patient-header__address">
            <i class="fas fa-map-marker-alt"></i>
            <span>{{ patient.address }}</span>
          </div>
        </div>
      </div>

      <div class="patient-header__care">
        <LoadingButton
          v-if="refreshHandler"
          class="btn btn-light-success btn-sm patient-header__refresh"
          :handler="refreshHandler"
        >
          <i class="fas fa-sync-alt mr-1"></i>Làm mới dữ liệu
        </LoadingButton>
        <div class="patient-header__program">
          <i class="fas fa-stethoscope"></i>
          <span>{{ patient.program }}</span>
        </div>
        <div class="patient-header__care-team">
          <div>BS: {{ patient.doctor }}</div>
          <div>Health Coach: {{ patient.healthCoach }}</div>
        </div>
      </div>
    </div>

    <div class="patient-header__diagnosis">
      Chẩn đoán: {{ patient.diagnosis }}
    </div>
  </section>
</template>

<script>
export default {
  name: 'PatientHeader',
  props: {
    patient: {
      type: Object,
      default: () => ({
        name: 'Nguyễn Văn A',
        phone: '0912345678',
        birthYear: '1985',
        address: '123 Đường ABC, Quận 1, TP.HCM',
        program: 'Quản lý đường huyết',
        doctor: 'BS. Trần Thị B',
        healthCoach: 'Nguyễn Thị C',
        diagnosis: 'Đái tháo đường type 2',
      }),
    },
    refreshHandler: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style scoped>
.patient-header {
  width: 100%;
  border-bottom: 1px solid #EBEDF3;
  padding: 20px 24px 0;
  background: #fff;
}

.patient-header__main {
  min-height: 88px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.patient-header__identity {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.patient-header__avatar {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  border-radius: 50%;
  background: #F3F6F9;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #7E8299;
  font-size: 32px;
  line-height: 1;
}

.patient-header__info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.patient-header__name {
  margin: 0;
  color: #181C32;
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
}

.patient-header__meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.patient-header__meta {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3F4254;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
}

.patient-header__meta i {
  width: 14px;
  flex: 0 0 14px;
  text-align: center;
  font-size: 13px;
  color: #B5B5C3;
}

.patient-header__address {
  max-width: 100%;
  font-size: 13px;
  line-height: 20px;
  color: #7E8299;
}

.patient-header__address span {
  overflow-wrap: anywhere;
}

.patient-header__care {
  width: 240px;
  flex: 0 0 240px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  text-align: right;
}

.patient-header__program {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 6px;
  background: #E8FFF3;
  color: #50CD89;
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
}

.patient-header__program i {
  font-size: 13px;
}

.patient-header__care-team {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  line-height: 20px;
  color: #7E8299;
}

.patient-header__diagnosis {
  min-height: 37px;
  border-top: 1px solid #EBEDF3;
  padding-top: 12px;
  color: #5E6278;
  font-size: 13px;
  line-height: 20px;
}

@media (max-width: 767.98px) {
  .patient-header {
    padding: 16px 16px 0;
  }

  .patient-header__main {
    flex-direction: column;
    gap: 12px;
  }

  .patient-header__care {
    width: 100%;
    flex-basis: auto;
    align-items: flex-start;
    text-align: left;
  }

  .patient-header__program {
    justify-content: flex-start;
  }

  .patient-header__avatar {
    width: 48px;
    height: 48px;
    flex-basis: 48px;
    font-size: 24px;
  }

  .patient-header__name {
    font-size: 20px;
    line-height: 28px;
  }
}
</style>
